import { render, staticRenderFns } from "./LicenseList.vue?vue&type=template&id=11ec7814"
import script from "./LicenseList.vue?vue&type=script&lang=js"
export * from "./LicenseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports